import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useUser } from '../context/user.context';
import { useForceUpdate } from '../misc/helpers';

// ======================================================= //

export default function EditPeriods({table, tableIndex, setTable}) {

    const forceUpdate = useForceUpdate();

    const {user, updateUser} = useUser();
    const [dialogOpen, setDialogOpen] = useState(false);

    const [periods, setPeriods] = useState(table.periods);
    const [valids, setValids] = useState([{s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}, {s: true, e: true}]);

    // ------------------------------------------------------- //

    const onChangeHide = (index, value) => {

        setPeriods(pr => {
            pr[index].hidden = !value;
            return pr;
        });
    }
    
    const onChangeStart = (index, value) => {

        let valid = value.match('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');

        if(valid === null) {
            
            setValids(p => {
                p[index].s = false;
                return p;
            })

            forceUpdate();
            return;
        }
        else {

            setValids(p => {
                p[index].s = true;
                return p;
            })
        
            forceUpdate();
        }

        setPeriods(pr => {
            pr[index].start = value;
            return pr;
        });
    }

    const onChangeEnd = (index, value) => {

        let valid = value.match('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');

        if(valid === null) {
            
            setValids(p => {
                p[index].e = false;
                return p;
            })

            forceUpdate();
            return;
        }
        else {

            setValids(p => {
                p[index].e = true;
                return p;
            })
        
            forceUpdate();
        }

        setPeriods(pr => {
            pr[index].end = value;
            return pr;
        });
    }

    // ------------------------------------------------------- //

    const saveEnabled = () => {

        let enabled = true;
        valids.forEach(element => {
            if(element.s === false || element.e === false) enabled = false;
        });

        return enabled;
    }

    const handleSave = () => {

        const new_user = {...user, periods: periods};

        updateUser(new_user);
        setDialogOpen(false);
    }

    // ------------------------------------------------------- //

    return (
        <React.Fragment>

            <Button 
                variant='contained' 
                size='small' fullWidth 
                sx={{marginTop: '5vh', color: "white", textTransform: 'none', letterSpacing: '0'}}
                onClick={() => setDialogOpen(true)}
            >
                Change Periods
            </Button> 

            <Dialog 
                open={dialogOpen}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Editing Periods</DialogTitle>

                <DialogContent
                    sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
                >

                    {
                        periods.map((v, i) => {
                            return (
                                <div key={i} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <Typography variant='caption' color='secondary'>
                                        Active?
                                    </Typography>

                                    <Checkbox
                                        defaultChecked={!v.hidden}
                                        disabled={i < 3}
                                        onChange={(event) => onChangeHide(i, event.target.checked)}
                                    />

                                    <TextField
                                        label={valids[i].s ? 'Start Time' : 'Error: Invalid Value!'}
                                        margin="dense"
                                        size="small"
                                        defaultValue={v.start}
                                        onChange={(event) => onChangeStart(i, event.target.value)}
                                        error={!valids[i].s}
                                    />

                                    <TextField
                                        label={valids[i].e ? 'End Time' : 'Error: Invalid Value!'}
                                        margin="dense"
                                        size="small"
                                        sx={{marginLeft: 2}}
                                        defaultValue={v.end}
                                        onChange={(event) => onChangeEnd(i, event.target.value)}
                                        error={!valids[i].e}
                                    />
                                </div>
                            )
                        })
                    } 

                </DialogContent>

                <DialogActions>
                    <Button disabled={!saveEnabled()} onClick={handleSave}>Save</Button>
                    <Button onClick={() => setDialogOpen(false)} color='secondary'>Cancel</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}